import { NavLink,useLocation } from "react-router";
import FondsItemComponent from "../../components/Fonds/FondsItem";
import { useFondPersoQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import {  type FetchBaseQueryError } from '@reduxjs/toolkit/query'
import type { LocationState } from "../../types/QueryParameters";

function FondPerso(){
    const location = useLocation();
    const state=location.state as LocationState | undefined;
    const { data:fond , error, isLoading } = useFondPersoQuery();
    const {translate}=useTrads();
    console.log(error);
    return (

        error ? (
            ( (error as FetchBaseQueryError).status==404) ?
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_404_fondperso')}</p> :
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            
            

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : fond ? (


       
            <div>
                
                <nav>
                    <NavLink to={`/perso/edit`}>{translate('btn_edit')}</NavLink>
                </nav>
               
                {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_fond_update')}</p>}
            <FondsItemComponent fond={fond}  />
            </div>
       
        ):null
    );
}
export default FondPerso;